import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getDealView = createAsyncThunk(
  "jointVenturesView/getDealView",
  async (dealId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getDealView?dealId=${encodeURIComponent(dealId)}`
      );
      return response?.response || response || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || err || "Failed to fetch deal view"
      );
    }
  }
);

const jointVenturesViewSlice = createSlice({
  name: "jointVenturesView",
  initialState: {
    dealViewData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDealView.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDealView.fulfilled, (state, action) => {
        state.loading = false;
        state.dealViewData = action.payload || null;
      })
      .addCase(getDealView.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch deal view";
      });
  },
});

export default jointVenturesViewSlice.reducer;